/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Set_New_End_Time_Last_EventInputs */



/**
* | output |
* | --- |
* | "Set new end time of last event" |
*
* @param {Set_New_End_Time_Last_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const set_new_end_time_last_event = /** @type {((inputs?: Set_New_End_Time_Last_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Set_New_End_Time_Last_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définir une nouvelle fin du dernier événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Endzeit für das letzte Ereignis festlegen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta una nuova ora di fine dell'ultimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить новое время окончания последнего события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer nueva hora de finalización del último evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置上一个事件的新结束时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のイベントの新しい終了時刻を設定する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम इवेंट का नया समाप्ति समय निर्धारित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Defina um novo horário de término para o último evento.")
	return /** @type {LocalizedString} */ ("Set new end time of last event")
});